/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Observer } from 'mobx-react';
import { useRootStore } from '../../../../stores/BridgeProvider';
import { safeEval } from '../../../util/UtilFunctions';
import { FlexDiv } from '../../../styles/styles';
import DtvtModal from './DtvtModal';
import { getColorByState } from '../../../../stores/dealMapperStore/dealMapUtil';
import RenderPropModal from '../../common/RenderPropModal';

const DtvtCard = ({ dtRefBox, itRefBox, containerRefBox, dtvt }) => (
  <Observer
    render={() => {
      const { dealMapperStore } = useRootStore();
      const { Amount, VoucherTranId, DealTranId } = dtvt;
      const { height: dtHeight, y: dtY } = dtRefBox;
      const { height: itHeight, y: itY } = itRefBox;
      const { y: containerY } = containerRefBox;
      const y1 = 0.5 * dtHeight + dtY - containerY;
      const y2 = 0.5 * itHeight + itY - containerY;
      const sumY = y1 + y2;
      const { backgroundColor } = getColorByState(dtvt);
      const isHovered = safeEval(
        () =>
          dealMapperStore.dealMapperViewStore.highlightedDtvts.some(
            dT =>
              dT.DealTranId === dtvt.DealTranId &&
              dT.VoucherTranId === dtvt.VoucherTranId,
          ),
        false,
      );

      return (
        <React.Fragment>
          <div
            style={{
              position: 'absolute',
              top: y1 < y2 ? y1 : y2,
              left: 0,
              width: 180,
              height: Math.abs(y2 - y1) > 1 ? Math.abs(y2 - y1) : 1,
              background:
                Math.abs(y2 - y1) > 1
                  ? `linear-gradient(to top ${
                      y1 < y2 ? 'right' : 'left'
                    }, transparent calc(50% - 1px), ${
                      isHovered ? '#01A1E8' : '#666'
                    }, transparent calc(50% + 1px) )`
                  : `${isHovered ? '#01A1E8' : '#666'}`,
              pointerEvents: 'none',
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              width: 90,
              height: 40,
              top: 0.5 * sumY - 20,
              left: 45,
            }}
          >
            <RenderPropModal
              manageHandleOpen
              cardDisplay={({ handleClose }) => (
                <FlexDiv>
                  <DtvtModal
                    dealTransactionId={DealTranId}
                    voucherTransactionId={VoucherTranId}
                    handleClose={handleClose}
                  />
                </FlexDiv>
              )}
              containerStyle={{
                height: '100%',
                width: '100%',
                display: 'flex',
              }}
              childContainerStyle={{
                display: 'flex',
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                background: backgroundColor,
                border: '1px solid #666',
                boxShadow: isHovered
                  ? 'inset 0px 0px 400px 110px rgba(0, 0, 0, .1)'
                  : 'none',
                zIndex: isHovered ? '99' : '1',
                borderRadius: '4px !important',
              }}
              enterHover={() => {
                dealMapperStore.dealMapperViewStore.setHoveredElement(dtvt);
              }}
              exitHover={() => {
                dealMapperStore.dealMapperViewStore.setHoveredElement(null);
              }}
            >
              {() => (
                <span style={{ color: '#666' }}>
                  ${parseFloat(Amount).toFixed(2)}
                </span>
              )}
            </RenderPropModal>
          </div>
        </React.Fragment>
      );
    }}
  />
);

export default DtvtCard;
